import React from "react";
import blogs from "./blogs";
import BlogCard from "./BlogCard";

const BlogLanding = () => {
  return (
    <section className="max-w-7xl mx-auto px-6 py-12">
      {/* Header */}
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-3xl font-bold">Latest Blogs</h1>
        <input
          type="text"
          placeholder="Search keywords..."
          className="px-4 py-2 rounded-full border border-gray-300 w-64 focus:outline-none"
        />
      </div>

      {/* Categories */}
      <div className="flex gap-6 border-b border-gray-200 mb-8 text-gray-600 font-medium">
        <button className="text-green-600 border-b-2 border-green-600 pb-2">
          All Blogs
        </button>
        <button>Business</button>
        <button>Consulting</button>
        <button>IT Services</button>
        <button>Logistics</button>
      </div>

      {/* Blog Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
        {blogs.slice(0, 6).map((blog) => (
          <BlogCard key={blog.id} blog={blog} />
        ))}
      </div>

      {/* View All Button */}
      <div className="flex justify-center mt-10">
        <button className="px-6 py-3 bg-green-600 text-white rounded-full font-medium hover:bg-green-700 transition">
          View All Blogs
        </button>
      </div>
    </section>
  );
};

export default BlogLanding;
    